/**
 * @generated SignedSource<<435d18d29ff056444f20c59282678540>>
 * @relayHash 0f778772b6735d8baf6fd48c7e856acd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a205234a2ffbde72b592f84d60e3bc9a68db317c41418c0908f53a2072264d8

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PermissionSchemesQuery$variables = {
  schemeId: string;
};
export type PermissionSchemesQuery$data = {
  readonly jira: {
    readonly viewPermissionScheme: {
      readonly configuration?: {
        readonly isEditable: boolean;
      };
      readonly " $fragmentSpreads": FragmentRefs<"Header_PermissionsAdministrationPagesPermissionScheme" | "PermissionsTable">;
    };
  } | null;
};
export type PermissionSchemesQuery = {
  response: PermissionSchemesQuery$data;
  variables: PermissionSchemesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "schemeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "schemeId",
    "variableName": "schemeId"
  }
],
v2 = {
  "concreteType": "JiraPermissionSchemeConfiguration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "description"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v6/*: any*/)
],
v9 = [
  (v4/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PermissionSchemesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v1/*: any*/),
              "kind": "LinkedField",
              "name": "viewPermissionScheme",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "Header_PermissionsAdministrationPagesPermissionScheme"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "PermissionsTable"
                    },
                    (v2/*: any*/)
                  ],
                  "type": "JiraPermissionSchemeView"
                }
              ]
            },
            "action": "THROW"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PermissionSchemesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "viewPermissionScheme",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraPermissionScheme",
                    "kind": "LinkedField",
                    "name": "scheme",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "JiraPermissionSchemeGrantGroup",
                    "kind": "LinkedField",
                    "name": "grantGroups",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectPermissionCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "JiraPermissionGrantHolder",
                        "kind": "LinkedField",
                        "name": "grantHolders",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraProjectPermission",
                            "kind": "LinkedField",
                            "name": "permission",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraPermissionGrants",
                            "kind": "LinkedField",
                            "name": "grants",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraGrantTypeKey",
                                "kind": "LinkedField",
                                "name": "grantType",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v4/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraPermissionGrantValue",
                                "kind": "LinkedField",
                                "name": "grantValues",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "type": "JiraDefaultGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": (v8/*: any*/)
                                          }
                                        ],
                                        "type": "JiraUserGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "concreteType": "JiraGroup",
                                            "kind": "LinkedField",
                                            "name": "group",
                                            "plural": false,
                                            "selections": (v9/*: any*/)
                                          }
                                        ],
                                        "type": "JiraGroupGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "field",
                                            "plural": false,
                                            "selections": (v8/*: any*/)
                                          }
                                        ],
                                        "type": "JiraIssueFieldGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "concreteType": "JiraRole",
                                            "kind": "LinkedField",
                                            "name": "role",
                                            "plural": false,
                                            "selections": (v9/*: any*/)
                                          }
                                        ],
                                        "type": "JiraProjectRoleGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/)
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      }
                                    ]
                                  },
                                  (v6/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v2/*: any*/)
                ],
                "type": "JiraPermissionSchemeView"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0a205234a2ffbde72b592f84d60e3bc9a68db317c41418c0908f53a2072264d8",
    "metadata": {},
    "name": "PermissionSchemesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "265a7e7442af91ff522bac9b0772faa6";

export default node;
